"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Route", {
  enumerable: true,
  get: function get() {
    return _reactRouter.Route;
  }
});
Object.defineProperty(exports, "Redirect", {
  enumerable: true,
  get: function get() {
    return _reactRouter.Redirect;
  }
});
Object.defineProperty(exports, "Switch", {
  enumerable: true,
  get: function get() {
    return _reactRouter.Switch;
  }
});
Object.defineProperty(exports, "Prompt", {
  enumerable: true,
  get: function get() {
    return _reactRouter.Prompt;
  }
});
Object.defineProperty(exports, "withRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouter.withRouter;
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.Link;
  }
});
Object.defineProperty(exports, "NavLink", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.NavLink;
  }
});
Object.defineProperty(exports, "connect", {
  enumerable: true,
  get: function get() {
    return _reactRedux.connect;
  }
});
Object.defineProperty(exports, "model", {
  enumerable: true,
  get: function get() {
    return _model["default"];
  }
});
Object.defineProperty(exports, "actions", {
  enumerable: true,
  get: function get() {
    return _actions.actions;
  }
});
Object.defineProperty(exports, "render", {
  enumerable: true,
  get: function get() {
    return _render["default"];
  }
});
Object.defineProperty(exports, "Provider", {
  enumerable: true,
  get: function get() {
    return _render.RootProvider;
  }
});
Object.defineProperty(exports, "hook", {
  enumerable: true,
  get: function get() {
    return _hook["default"];
  }
});
Object.defineProperty(exports, "Router", {
  enumerable: true,
  get: function get() {
    return _router["default"];
  }
});
Object.defineProperty(exports, "defaults", {
  enumerable: true,
  get: function get() {
    return _defaults["default"];
  }
});
Object.defineProperty(exports, "toReducers", {
  enumerable: true,
  get: function get() {
    return _toReducers["default"];
  }
});
exports.middleware = void 0;

var _reactRouter = require("react-router");

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _model = _interopRequireDefault(require("./model"));

var _actions = require("./actions");

var _render = _interopRequireWildcard(require("./render"));

var _hook = _interopRequireDefault(require("./hook"));

var _router = _interopRequireDefault(require("./router"));

var _defaults = _interopRequireDefault(require("./defaults"));

var _middleware = _interopRequireDefault(require("./middleware"));

var _toReducers = _interopRequireDefault(require("./toReducers"));

var middleware = (0, _middleware["default"])();
exports.middleware = middleware;